exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".JoCloseWarningPopup_buttonWrapper__3B0EC{display:-webkit-flex;display:flex;-webkit-justify-content:center;justify-content:center}", ""]);

// exports
exports.locals = {
	"buttonWrapper": "JoCloseWarningPopup_buttonWrapper__3B0EC"
};